import * as React from 'react';
import s from '../../PlansPage.scss';

export const GridWrapper: React.FC = ({ children }) => {
  return <div className={s.gridWidth}>{children}</div>;
};
